import PropTypes from 'prop-types';

/**
 * The type of a styles object that can be passed as argument to the
 * [Glamor](https://github.com/threepointone/glamor) `css` function, i.e. either a vanilla object
 * like `{ color: 'red' }` or a precompiled Glamor object like `css({ color: 'red' })`, or an array
 * of such elements.
 */
export const cssPropType = PropTypes.oneOfType([PropTypes.object, PropTypes.array]);
